import { type OpenApiSchemaMapping } from '#shared/api/schema';
import { type TagWithScope } from '#shared/lib/integrations';
import { INTEGRATION_MAPPING_STATIC_ITEMS } from '#shared/lib/integrations';

type CharacteristicListItem = {
    id: string;
    title: string;
};

export const mapMappingToTags = (
    mapping: OpenApiSchemaMapping | undefined,
    characteristics: CharacteristicListItem[]
): TagWithScope[] => {
    const items: TagWithScope[] = [];

    mapping?.custom_slugs.forEach((customSlug) => {
        const found = INTEGRATION_MAPPING_STATIC_ITEMS.find((item) => item.value === customSlug);

        if (found) {
            items.push({ key: found.value, tag: found.content, scopeArea: 'property' });
        }
    });

    mapping?.characteristic_ids.forEach((characteristicId) => {
        const found = characteristics.find((characteristic) => characteristic.id === characteristicId);

        if (found) {
            items.push({ key: found.id, tag: found.title, scopeArea: 'characteristic' });
        }
    });

    return items;
};
